// This file is used for LOCAL DEVELOPMENT ONLY
// In production, configuration is loaded from /aws-exports.js (generated by Terraform)

const awsmobile = {
    Auth: {
        Cognito: {
            userPoolId: "ca-central-1_2Ps0YZ7vy",
            userPoolClientId: "59n0i2uunlopnfb6p30q2vfb8",
            region: "ca-central-1"
        }
    },
    API: {
        REST: {
            AdminAPI: {
                endpoint: "https://dev-pix-api.rebeccaandjim.ca",
                region: "ca-central-1"
            }
        }
    }
};

export default awsmobile;